import { Component } from '@angular/core';

@Component({
  selector: 'shared-local-dot-loader',
  templateUrl: './local-dot-loader.component.html',
  styleUrl: './local-dot-loader.component.scss',
  standalone: false,
})
export class LocalDotLoaderComponent {}
